import { datadogRum } from '@datadog/browser-rum';
import { constants } from './definitions';
import { gitSha, twilioRealm } from '../../app/utils';

export const initializeRum = (): void => {
  datadogRum.init({
    applicationId: constants.APPLICATION_ID,
    clientToken: constants.CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'one-support-center',
    env: twilioRealm,
    version: gitSha,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
};
